import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { listPiiInfoTypes } from '@kirin/api-client/api/policies';
import { type PiiInfoTypeOption } from '@kirin/api-client/contracts/pii-info-types';

/**
 * KIR-3837: the DLP infoTypes selectable in the PII Detection policy picker,
 * from GET /api/pii/info-types (curated types + the full DLP catalog, overlaid
 * with Kirin sensitivity / higher-latency metadata). Server-cached and stable
 * over a deploy, so cached for an hour client-side.
 */
export function usePiiInfoTypes(enabled = true): {
  options: PiiInfoTypeOption[];
  isLoading: boolean;
  isError: boolean;
} {
  const query = useQuery({
    queryKey: ['pii', 'info-types'] as const,
    queryFn: () => listPiiInfoTypes(apiClient),
    staleTime: 60 * 60 * 1000,
    enabled,
  });

  return {
    options: query.data?.infoTypes ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
